import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Card,
  CardHeader,
  CardBody,
  Table,
  Button,
  Row,
  Col,
  Badge
} from 'reactstrap';
import { getProjects, deleteProject } from '../../actions/projectAction';
import ProjectCreateModal from './ProjectCreateModal';
import ProjectEditModal from './ProjectEditModal';

class ProjectView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createModal: false,
      editModal: false,
      selectedProject: null
    };
  }

  componentDidMount() {
    this.props.getProjects();
  }

  toggleCreateModal = () => {
    this.setState(prevState => ({
      createModal: !prevState.createModal
    }));
  };

  toggleEditModal = (project = null) => {
    this.setState(prevState => ({
      editModal: !prevState.editModal,
      selectedProject: project
    }));
  };

  handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this project?')) {
      this.props.deleteProject(id);
    }
  };

  render() {
    const { projects, loading, error } = this.props.project;
    const { createModal, editModal, selectedProject } = this.state;

    if (loading) return <div>Loading...</div>;
    if (error) return <div>Error: {error.message}</div>;

    return (
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="6">
                    <h4 className="title">Projects</h4>
                  </Col>
                  <Col md="6" className="text-right">
                    <Button color="primary" onClick={this.toggleCreateModal}>
                      Create Project
                    </Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Status</th>
                      <th>Assigned To</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {projects.map(project => (
                      <tr key={project._id}>
                        <td>{project.title}</td>
                        <td>{project.description}</td>
                        <td>
                          <Badge color={
                            project.status === 'active' ? 'success' :
                            project.status === 'archived' ? 'warning' : 'danger'
                          }>
                            {project.status}
                          </Badge>
                        </td>
                        <td>{project.assigned_to}</td>
                        <td>
                          <Button
                            color="info"
                            size="sm"
                            onClick={() => this.toggleEditModal(project)}
                          >
                            Edit
                          </Button>
                          {' '}
                          <Button
                            color="danger"
                            size="sm"
                            onClick={() => this.handleDelete(project._id)}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </CardBody>
            </Card>
          </Col>
        </Row>

        <ProjectCreateModal
          isOpen={createModal}
          toggle={this.toggleCreateModal}
        />

        <ProjectEditModal
          isOpen={editModal}
          toggle={() => this.toggleEditModal()}
          project={selectedProject}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  project: state.project
});

export default connect(mapStateToProps, { getProjects, deleteProject })(ProjectView); 